import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';
import NatureOfSuitTooltip from '../tooltips/NatureOfSuitTooltip';
import natureOfSuitOptions from '../../../../data/appellateNosOptions';

import './NatureOfSuitOfAppellete.less';

function NatureOfSuitOfAppellete({ className, filters, onChange }) {
  return (
    <div className="nature-of-suit-selector-container">
      <label style={{ fontWeight: 700 }} className="nature-of-suit-selector-label" htmlFor="nature-of-suit-selector">
        Nature of Suit:
      </label>
      <br />
      <div className={`nature-of-suit-selector ${className}`}>
        <Select
          name="nature-of-suit-field-name"
          options={natureOfSuitOptions}
          multi
          simpleValue
          value={filters.get('nos')}
          placeholder="Select..."
          onChange={nos => onChange({ nos: nos || '' })}
        />
      </div>
      <NatureOfSuitTooltip />
    </div>
  );
}

NatureOfSuitOfAppellete.propTypes = {
  onChange: PropTypes.func,
  filters: PropTypes.any.isRequired,
  className: PropTypes.string,
};

NatureOfSuitOfAppellete.defaultProps = {
  onChange: () => {},
  className: '',
};

export default connect(state => mapValidationFieldsToClassName(state, 'nos', 'nos-selector'))(NatureOfSuitOfAppellete);



// WEBPACK FOOTER //
// ./src/components/search/FormElements/NatureOfSuitOfAppellete/NatureOfSuitOfAppellete.js